<template>
	<modal
		size="small-medium"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<h3>{{ $t('Limit') }} {{replaceString(data.name)}}</h3>
		</template>
		<template slot="body">
			<form @submit.prevent="updateLimit">
				<!-- Feature Name -->
				<div class="d-flex">
					<h5 class="col-md-4 pt-2 pl-0 mr-0">{{ $t('Current Limit') }}</h5>
					<custom-input
						v-if="data.name !== 'storage'"
						type="number"
						align="left"
						:min="data.originalLimit"
						:max="99999999999999"
						v-model="data.totalLimit"
						@keyenter="onInputEnter('limit', ...arguments)"
					/>
					<custom-input
						v-if="data.name === 'storage'"
						type="number"
						align="left"
						:min="data.originalLimit"
						:max="99999999999999"
						v-model="data.totalLimit"
						:suffix="'Mb'"
						@keyenter="onInputEnter('limit', ...arguments)"
					/>
				</div>
				<!-- Submit -->
				<div class="text-right">
					<button
						type="submit"
						class="btn btn-submit btn-primary mt-3"
						:class="{ 'is-loading': isSaving }">
						{{ $t('Update') }}
					</button>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import CustomInput from '@/components/CustomInput.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import usersApi from '@/api/user';

export default {
	name: 'PackageFeatureForm',
	props: {
		data: {
			type: Object,
		},
	},
	components: {
		Modal,
		CustomInput,
	},
	data() {
		return {
			isSaving: false,
			limitFeature: 0,
		};
	},
	methods: {
		updateLimit() {
			this.isSaving = true;
			const callback = (response) => {
				const user = response.data;
				const message = response.message;
				this.$emit('saved', user);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add user',
					text: message,
				});
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add user',
					text: message,
				});
				this.isSaving = false;
			};
			const params = {
				user_id: this.data.userId,
				type: this.data.name,
			};
			if (this.data.totalLimit >= this.data.originalLimit) {
				params.limit = this.data.totalLimit - this.data.originalLimit;
			} else {
				params.limit = 0;
			}
			usersApi.updateLimit(params, callback, errorCallback);
		},
		close() {
			this.$emit('close');
		},
		replaceString(string) {
			return string.replaceAll('_', ' ');
		},
		onInputEnter(props, value) {
			if (props === 'limit') this.data.totalLimit = value;
			this.updateLimit();
		},
	},
	computed: {
	},
	watch: {
	},
	created() {
	},
};
</script>
